<template>
  <div class="register-sharer-page">
    <div class="register-sharer-page-title">请注册分享人信息</div>
    <van-field
      v-model="form.invitationCode"
      label="邀请码："
      placeholder="请输入邀请码"
      :clearable="true"
      maxlength="6"
    />
    <van-field
      v-model="form.employeeName"
      label="姓名："
      placeholder="请输入姓名"
      :clearable="true"
      maxlength="150"
    />
    <van-field
      v-model="form.phone"
      label="手机号："
      placeholder="请输入手机号"
      :clearable="true"
      :disabled="true"
    />

    <div class="register-sharer-page-btn-wrap">
      <div
        class="register-sharer-page-btn"
        @click="submitRegister"
      >
        提交注册
      </div>
      <div
        v-if="$parent.$parent.showBottomNavBar"
        class="h-bottom-nav"
      />
    </div>
  </div>
</template>

<script>
import { registerAgentEmployee } from '../common/api.js';

class Form {
  agencyCode = ''; // 代理商code
  invitationCode = ''; // 邀请码
  employeeName = ''; // 姓名
  phone = ''; // 手机号
}

export default {
  name: 'RegisterSharer',
  data() {
    return {
      form: new Form()
    };
  },
  mounted() {
    this.form.phone = localStorage.getItem('_phone') || '';
    this.form.agencyCode = localStorage.getItem('_encryptAgencyCode') || '';
  },
  methods: {
    // 检验邀请码
    checkInvitationCode() {
      return this.form.invitationCode === this.form.agencyCode.slice(-6);
    },
    // 去注册
    submitRegister() {
      if (!this.form.invitationCode) {
        this.$toast('请输入邀请码');
        return;
      }
      if (!this.form.employeeName) {
        this.$toast('请输入姓名');
        return;
      }
      if (!this.form.phone) {
        this.$toast('请输入手机号');
        return;
      }
      if (!this.checkInvitationCode()) {
        this.$toast('注册失败，邀请码输入错误');
        return;
      }
      this.$toast.loading({
        message: '注册中...',
        forbidClick: true,
        duration: 0
      });
      registerAgentEmployee(this.form).then((res) => {
        if (res.isRegister) {
          this.$parent.toJudgeAgentEmployee();
          this.$toast('注册成功');
        } else {
          this.$toast(res.message);
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.register-sharer-page {
  height: 100vh;
  background: #ffffff;
  box-sizing: border-box;
  padding: 80px 32px;
  position: relative;

  .register-sharer-page-title {
    font-size: 40px;
    color: #383838;
    font-weight: bold;
    margin-bottom: 48px;
  }
  .register-sharer-page-btn-wrap {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100vw;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 15px 32px;
    box-sizing: border-box;
    background: #ffffff;
    box-shadow: inset 0px 1px 0px 0px rgba(230, 230, 230, 1);

    .register-sharer-page-btn {
      background: #fe6456;
      border-radius: 20px;
      font-size: 32px;
      color: #ffffff;
      text-align: center;
      font-weight: 400;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 90px;
    }
  }
}
.van-cell {
  background: #f0f0f0;
  border-radius: 20px;
  margin-bottom: 32px;
  height: 100px;
  display: flex;
  align-items: center;
  padding: 28px 32px;
}
/deep/ .van-cell__title {
  font-size: 30px;
  color: #383838;
  font-weight: 400;
  height: 45px;
  width: 130px;
  margin: 0px;
}
/deep/ .van-field__control {
  font-size: 30px !important;
  color: #383838;
  font-weight: bold;

  &::placeholder {
    font-size: 30px !important;
    color: #999999;
    font-weight: 400;
  }
}
.h-bottom-nav {
  height: calc(98px + constant(safe-area-inset-bottom));
  height: calc(98px + env(safe-area-inset-bottom));
}
</style>
